const programmeBreadcrumb = { name: "Programmes", route: "project-list" };

function numericProgrammeProps(route) {
  return {
    id: Number(route.params.id),
    projectId: Number(route.params.id),
    programmeId: Number(route.params.id),
  };
}

function redirectToWorkspace(to) {
  return {
    name: "project-workspace",
    params: { id: to.params.id },
    query: to.query,
    hash: to.hash,
  };
}

export default [
  {
    path: "/programmes/",
    name: "project-list",
    component: () => import("@/features/programme/pages/ProgrammeListPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "app",
      group: "Programmes",
      title: "Programmes",
      breadcrumbs: [programmeBreadcrumb],
    },
  },

  {
    path: "/programmes/:id/",
    name: "programme-root-legacy",
    redirect: redirectToWorkspace,
  },

  {
    path: "/programmes/:id/workspace/",
    name: "project-workspace",
    component: () => import("@/features/programme/pages/ProgrammeWorkspacePage.vue"),
    props: numericProgrammeProps,
    meta: {
      requiresAuth: true,
      layout: "app",
      group: "Programmes",
      title: "Scenario Select",
      breadcrumbs: [
        programmeBreadcrumb,
        { name: "Scenario Select", route: "project-workspace" },
      ],
    },
  },

  {
    path: "/programmes/:id/overview/",
    name: "programme-overview-legacy",
    redirect: redirectToWorkspace,
  },

  {
    path: "/programmes/:id/scenarios/",
    name: "scenario-manager",
    redirect: redirectToWorkspace,
  },

  {
    path: "/projects/:id/scenarios/",
    name: "project-scenarios-legacy",
    redirect: redirectToWorkspace,
  },

  {
    path: "/programmes/detail/:id/",
    name: "project-detail-legacy",
    redirect: redirectToWorkspace,
  },

  {
    path: "/programmes/edit/:id/scenarios/",
    name: "programme-edit-scenarios-legacy",
    redirect: redirectToWorkspace,
  },

  {
    path: "/programmes/:id/setup-legacy/",
    name: "project-setup",
    redirect: (to) => ({
      name: "programme-setup",
      params: { id: to.params.id },
      query: to.query,
      hash: to.hash,
    }),
  },
];